export const TICKET_STATUSES = [
  { id: "new", name: "New", class: "bg-info" },
  { id: "open", name: "Open", class: "bg-primary" },
  { id: "pending", name: "Pending", class: "bg-warning" },
  { id: "resolved", name: "Resolved", class: "bg-success" },
  { id: "closed", name: "Closed", class: "bg-secondary" },
];

export const TICKET_PRIORITIES = [
  { id: "low", name: "Low", class: "bg-secondary" },
  { id: "normal", name: "Normal", class: "bg-info" },
  { id: "medium", name: "Medium", class: "bg-info" },
  { id: "high", name: "High", class: "bg-warning" },
  { id: "urgent", name: "Urgent", class: "bg-danger" },
];

export const TICKET_CATEGORIES = [
  { id: "general", name: "General" },
  { id: "support", name: "Support" },
  { id: "billing", name: "Billing" },
  { id: "technical", name: "Technical" },
  { id: "feedback", name: "Feedback" },
];
